import script from "./NotificationShow.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationShow.vue?vue&type=script&setup=true&lang=js"

import "./NotificationShow.vue?vue&type=style&index=0&id=61d13242&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d13242"]])

export default __exports__